import { z } from "zod";

export function validarCPF(cpf: string): boolean {
  cpf = cpf.replace(/\D/g, "");

  if (cpf.length !== 11) {
    return false;
  }

  if (/^(\d)\1+$/.test(cpf)) {
    return false;
  }

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cpf.charAt(i)) * (10 - i);
  }

  let remainder = sum % 11;
  const digit1 = remainder < 2 ? 0 : 11 - remainder;

  if (parseInt(cpf.charAt(9)) !== digit1) {
    return false;
  }

  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cpf.charAt(i)) * (11 - i);
  }

  remainder = sum % 11;
  const digit2 = remainder < 2 ? 0 : 11 - remainder;

  return parseInt(cpf.charAt(10)) === digit2;
}

export function validarCNPJ(cnpj: string): boolean {
  cnpj = cnpj.replace(/\D/g, "");

  if (cnpj.length !== 14) {
    return false;
  }

  if (/^(\d)\1+$/.test(cnpj)) {
    return false;
  }

  let size = cnpj.length - 2;
  let numbers = cnpj.substring(0, size);
  const digits = cnpj.substring(size);
  let sum = 0;
  let pos = size - 7;

  for (let i = size; i >= 1; i--) {
    sum += parseInt(numbers.charAt(size - i)) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }

  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== parseInt(digits.charAt(0))) {
    return false;
  }

  size = size + 1;
  numbers = cnpj.substring(0, size);
  sum = 0;
  pos = size - 7;

  for (let i = size; i >= 1; i--) {
    sum += parseInt(numbers.charAt(size - i)) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }

  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

  return result === parseInt(digits.charAt(1));
}

export const CreateUserCustomerIdFormSchema = z.object({
  cpfCnpj: z
    .string()
    .regex(/^\d{11}$|^\d{14}$/, { message: "CPF ou CNPJ inválido" })
    .refine((value) => validarCPF(value) || validarCNPJ(value), {
      message: "CPF ou CNPJ inválido",
    }),
  address: z.string().min(3, { message: "Endereço inválido" }),
  addressNumber: z.string().min(1, { message: "Número inválido" }),
  complement: z.string().optional(),
  neighborhood: z.string().min(3, { message: "Bairro inválido" }),
  city: z.string().min(3, { message: "Cidade inválida" }),
  province: z.string().min(3, { message: "Estado inválido" }),
  postalCode: z.string().regex(/^\d{8}$/, { message: "CEP inválido" }),
  country: z.string().min(2, { message: "País inválido" }),
});
